import React from "react";
import {
  FooterContainer,
  FooterH2,
  FooterLink,
  FooterWrapper,
} from "./FooterElements";
import "./../../App.css";



const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper className="container py-5">
        <div className="row gx-5 px-4 gy-4">
          <div className="col-lg-3 col-sm-6">
            <FooterH2>About Us</FooterH2>
            <FooterLink href="#">We Are</FooterLink>
            <FooterLink href="#">Web Development,</FooterLink>
            <FooterLink href="#">Software Development</FooterLink>
            <FooterLink href="#">Agency of</FooterLink>
            <FooterLink href="#"> Jabalpur </FooterLink>
          </div>
          <div className="col-lg-3 col-sm-6">
            <FooterH2>Contact Us</FooterH2>
            <FooterLink href="/ContactForm">Contact</FooterLink>
            <FooterLink href="https://discord.gg/TUK2HRng5s">Support</FooterLink>
            <FooterLink href="#">Mob (+917828606108)</FooterLink>
            <FooterLink href="#">Mob (+919340726767)</FooterLink>
            <FooterLink href="mailto:ksadik320@gmail.com">ksadik320@gmail.com</FooterLink>
          </div>
          <div className="col-lg-3 col-sm-6">
            <FooterH2>Customers</FooterH2>
            <FooterLink href="https://discord.gg/TUK2HRng5s">Our Customers</FooterLink>
            <FooterLink href="https://discord.gg/TUK2HRng5s">How to reach us</FooterLink>
            <FooterLink href="https://discord.gg/TUK2HRng5s">Video Samples</FooterLink>
            <FooterLink href="https://discord.gg/TUK2HRng5s">Agency</FooterLink>
          </div>
          <div className="col-lg-3 col-sm-6">
            <FooterH2>Our Location</FooterH2>
            <FooterLink href="#">*Near Ojhas Empire, Gwarighat, Jabalpur</FooterLink>
            <FooterLink href="#">*3200 Adhartal Jabalpur</FooterLink>
          </div>
        </div>
        <div className="row mt-3 copyright-social-links outer-container">
          <hr />
          <div className="col-md-6">
            Copyright &copy; 2023. All Rights Reserved By CyberSaviour
          </div>
          </div>
        <div className="row">
          <div className="col-12 mt-5 ">
            <h1 className="logo-text gray-text center-align">- CyberSaviour -</h1>
          </div>
        </div>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default Footer;
